module.exports = __webpack_public_path__ + "static/media/member (1).659afe3d.png";